var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Title } from "@angular/platform-browser";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NotificationsService } from "angular2-notifications";
import { School } from "../models/school.model";
import { UserProfile } from "../models/userProfile.model";
import { CookiesService } from "../services/cookies.service";
import { UserProfileService } from "../services/user-profile.service";
import { UserService } from "../services/user.service";
import { GTMService } from "../services/gtm.service";
import { AddSchoolModalComponent } from "../shared-components/modals/add-school-modal/add-school-modal.component";
import { EduComponent } from "../utils/eduComponent";
import { getDRFErrorMessages } from "../utils/error-handling";
import { ChangePasswordModalComponent } from "../shared-components/modals/change-password-modal/change-password-modal.component";
import Utils from "../utils/utils";
import { PBSLM_TITLE, SUGGESTED_SCHOOL_ID } from "../models/constants";
import { LocalizationModalComponent } from "../shared-components/modals/localization-modal/localization-modal.component";
import { LocalizationService } from "../services/localization.service";
import { NotificationModalComponent } from "../shared-components/modals/notification-modal/notification-modal.component";
var UserProfileComponent = /** @class */ (function (_super) {
    __extends(UserProfileComponent, _super);
    function UserProfileComponent(userProfileService, cookieService, userService, notificationService, gtmService, titleService, localizationService, modalService) {
        var _this = _super.call(this) || this;
        _this.userProfileService = userProfileService;
        _this.cookieService = cookieService;
        _this.userService = userService;
        _this.notificationService = notificationService;
        _this.gtmService = gtmService;
        _this.titleService = titleService;
        _this.localizationService = localizationService;
        _this.modalService = modalService;
        _this.schools = [];
        _this.roles = [];
        _this.grades = [];
        _this.subjects = [];
        _this.suggestedSchool = {};
        _this.stateStandards = "";
        _this.localizationLogo = "";
        _this.googleClassImg = "";
        _this.zipCode = "None";
        _this.isProfileSuccessfullySaved = true;
        _this.titleService.setTitle("Profile | " + PBSLM_TITLE);
        _this.gtmService.pushCleanPageView();
        _this.studentCalloutImage = require("../../../../lmfrontend/src/assets/teacher-and-students.png");
        _this.googleClassImg = require("../../assets/google_classroom_x48_yellow_stroke_icon.png");
        return _this;
    }
    UserProfileComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.roles = this.userProfileService.getTeacherRoles();
        this.grades = this.userProfileService.getGrades();
        this.subjects = this.userProfileService.getSubjects();
        this.addSub(this.localizationService.localizeData.subscribe(function (data) {
            _this.stateStandards = data.stateStandards;
            _this.localizationLogo = data.getLogo();
        }));
        this.addSub(this.userProfileService.getUserProfile().subscribe(function (response) {
            _this.userProfile = new UserProfile(response);
            _this.zipCode = _this.userProfile.zipCode;
            _this.refreshAvailableSchools();
            if (_this.userProfile.userRole) {
                _this.selectedRole = _this.preselectSelectorValue(_this.roles, _this.userProfile.userRole, "value");
            }
            else {
                _this.selectedRole = { id: null, value: "No role selected" };
            }
            _this.gradesCheckboxesModel = _this.buildGradesPanel(_this.userProfile.gradeRange, _this.grades);
            _this.subjectsCheckboxModel = _this.buildSubjectsPanel(_this.userProfile.preferredSubjects, _this.subjects);
            if (_this.userService.shouldShowVirginiaModal) {
                var localizationModal = _this.modalService.open(LocalizationModalComponent);
                localizationModal.componentInstance.virginiaLocalization = true;
                _this.userService.shouldShowVirginiaModal = false;
            }
        }));
    };
    UserProfileComponent.prototype.refreshAvailableSchools = function () {
        var _this = this;
        this.addSub(this.userProfileService
            .getAvailableSchools(this.userProfile.zipCode)
            .subscribe(function (response) {
            _this.schools = response.schools;
            _this.schools.push({ id: null, name: "No school selected" });
            _this.selectedSchool = _this.preselectSelectorValue(_this.schools, _this.userProfile.userSchool, "id");
        }));
    };
    UserProfileComponent.prototype.updateProfile = function () {
        var _this = this;
        var nextUrl = this.cookieService.getCookie("next");
        this.userProfile.gradeRange = this.generateGradesRange(this.gradesCheckboxesModel);
        this.userProfile.preferredSubjects = this.generatePreferredSubjects(this.subjectsCheckboxModel);
        if (this.selectedRole.id) {
            this.userProfile.userRole = this.selectedRole.value;
        }
        else {
            this.userProfile.userRole = this.selectedRole.id;
        }
        if (this.selectedSchool) {
            this.userProfile.userSchool = this.selectedSchool.id;
        }
        this.addSub(this.userProfileService
            .updateUserProfile(this.userProfile.reverseToApiResponse(), this.buildHttpHeaders())
            .subscribe(function (response) {
            _this.isProfileSuccessfullySaved = true;
            if (nextUrl) {
                _this.cookieService.deleteCookie("next");
                window.location.replace(nextUrl.value);
            }
        }, function (error) {
            var errors = getDRFErrorMessages(error);
            if (errors && errors.length > 0) {
                errors.forEach(function (errorMsg) {
                    _this.isProfileSuccessfullySaved = false;
                });
            }
            else {
                _this.isProfileSuccessfullySaved = false;
            }
        }));
    };
    // INFO:
    // > optionsArray: (The) array that keeps available options for selector.
    // > defaultSelection: (The) default option user had set.
    // > optionNameField: (The) field used to determine the value (name) of the option.
    UserProfileComponent.prototype.preselectSelectorValue = function (optionsArray, defaultSelection, optionNameField) {
        return optionsArray.find(function (item) { return item[optionNameField] === defaultSelection; });
    };
    UserProfileComponent.prototype.changeCheckboxesModel = function (newValue, item, checkboxesModel) {
        var checkbox = checkboxesModel.find(function (x) { return x.label === item.label; });
        if (checkbox && checkbox.checkValue !== undefined) {
            checkbox.checkValue = newValue;
        }
    };
    UserProfileComponent.prototype.buildGradesPanel = function (preselectedGradesRange, defaultGrades) {
        var checkedOptions = preselectedGradesRange.split(",");
        var defaultModel = defaultGrades.map(function (item) {
            return { label: item, checkValue: false };
        });
        defaultModel.forEach(function (item) {
            if (checkedOptions.find(function (el) { return el === item.label; })) {
                item.checkValue = true;
            }
        });
        return defaultModel;
    };
    UserProfileComponent.prototype.buildSubjectsPanel = function (preselectedSubjects, defaultSubjects) {
        var defaultModel = defaultSubjects.map(function (item) {
            return { label: item.label, id: item.id, checkValue: false };
        });
        defaultModel.forEach(function (item) {
            if (preselectedSubjects.find(function (el) { return el === item.id; })) {
                item.checkValue = true;
            }
        });
        return defaultModel;
    };
    UserProfileComponent.prototype.generateGradesRange = function (gradesCheckboxesModel) {
        return gradesCheckboxesModel
            .map(function (item) {
            if (item.checkValue === true) {
                return item.label;
            }
        })
            .filter(function (item) { return item != null; })
            .toString();
    };
    UserProfileComponent.prototype.generatePreferredSubjects = function (subjectsCheckboxModel) {
        return subjectsCheckboxModel
            .map(function (item) {
            if (item.checkValue === true) {
                return item.id;
            }
        })
            .filter(function (item) { return item != null; });
    };
    UserProfileComponent.prototype.getAccountEditLink = function () {
        return this.userService.userAccountEditUrl;
    };
    // TODO: Move this in the user profile service
    UserProfileComponent.prototype.buildHttpHeaders = function () {
        var csrfCookie = this.cookieService.getCookie("csrftoken");
        var csrfToken = "";
        if (csrfCookie) {
            csrfToken = csrfCookie.value;
        }
        return {
            headers: {
                "Content-Type": "application/json",
                "X-CSRFTOKEN": csrfToken,
            },
        };
    };
    UserProfileComponent.prototype.openAddSchoolModal = function () {
        var _this = this;
        this.suggestNewSchoolModalRef = this.modalService.open(AddSchoolModalComponent, { size: "lg" });
        this.suggestNewSchoolModalRef.componentInstance.suggestedSchool = this.suggestedSchool;
        this.suggestNewSchoolModalRef.componentInstance.states = this.userProfileService.getStates();
        this.suggestNewSchoolModalRef.componentInstance.handler.subscribe(function (response) {
            _this.suggestSchool(response);
        });
    };
    UserProfileComponent.prototype.suggestSchool = function (response) {
        var _this = this;
        var suggestedSchool = new School(response);
        if (suggestedSchool.name !== "" && suggestedSchool.zipCode !== "") {
            this.addSub(this.userProfileService
                .postNewSchool(suggestedSchool.generateApiPayload(), {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
            })
                .subscribe(function (response) {
                var informationModal = _this.modalService.open(NotificationModalComponent);
                informationModal.componentInstance.message =
                    "Your school was successfully added to your profile.";
                _this.userProfile.userSchool = SUGGESTED_SCHOOL_ID;
                _this.refreshAvailableSchools();
            }, function (error) {
                var errors = getDRFErrorMessages(error, [
                    "user_role",
                ]);
                if (errors && errors.length > 0) {
                    errors.forEach(function (errorMsg) {
                        _this.notificationService.error("Error", errorMsg, Utils.alertConfiguration);
                    });
                }
                else {
                    _this.notificationService.error("Error", "Please try again later.", Utils.alertConfiguration);
                }
            }));
        }
    };
    UserProfileComponent.prototype.clickChangePassword = function () {
        this.updateProfile();
        this.modalService.open(ChangePasswordModalComponent);
    };
    UserProfileComponent.prototype.copyToClipboard = function () {
        var redirectLink = window.location.host + "/student/signup/";
        Utils.copyTextToClipboard(redirectLink);
        this.notificationService.success("Success!", "Link copied to clipboard.", Utils.alertConfiguration);
    };
    UserProfileComponent.prototype.openLocalizationChangeModal = function () {
        this.updateProfile();
        this.modalService.open(LocalizationModalComponent, {
            size: "lg",
            windowClass: "change-station-modal",
        });
    };
    UserProfileComponent.prototype.openProfileUpdateConfirmationModal = function () {
        var notificationModal = this.modalService.open(NotificationModalComponent);
        if (this.isProfileSuccessfullySaved) {
            notificationModal.componentInstance.message =
                "Your profile information has been saved.";
        }
        else {
            notificationModal.componentInstance.message =
                "Something unexpected happened and the profile changes couldn't be saved. Please try again!";
        }
    };
    return UserProfileComponent;
}(EduComponent));
export { UserProfileComponent };
